import {
  adminControlFeatures,
  codeScanningFeatures,
  complianceFeatures,
  deploymentFeatures,
  type FullTierDescription,
  mainFeatures,
  qualityFeatures,
  reportingFeatures,
  sbomFeatures,
  securityFeatures,
  supportFeatures,
} from './consts';

const enterpriseTierFeatures: FullTierDescription = {
  mainFeatures: {
    [mainFeatures.projectsFeature]: 'Unlimited',
    [mainFeatures.contributingDevelopers]: '',
    [mainFeatures.releaseGroupsFeature]: 'Unlimited',
    [mainFeatures.continuousMonitoringFeature]: true,
    [mainFeatures.apiSupportFeature]: true,
    [mainFeatures.packageIndexFeature]: true,
    [mainFeatures.issueDashboardFeature]: true,
    [mainFeatures.autoIgnoreRulesFeature]: true,
    [mainFeatures.issueFiltersFeature]: true,
    [mainFeatures.savedFiltersFeature]: true,
  },
  codeScanningFeatures: {
    [codeScanningFeatures.sourceCodeScanningFeature]: true,
    [codeScanningFeatures.deepDepDiscoveryFeature]: true,
    [codeScanningFeatures.quickImportGitHubFeature]: true,
    [codeScanningFeatures.cicdIntegrationFeature]: true,
    [codeScanningFeatures.branchTagScanningFeature]: true,
    [codeScanningFeatures.containerScanningFeature]: true,
    [codeScanningFeatures.archiveScanningFeature]: true,
  },
  securityFeatures: {
    [securityFeatures.vulnIdentificationFeature]: true,
    [securityFeatures.vulnManagementFeature]: true,
    [securityFeatures.defaultSecurityPoliciesFeature]: true,
    [securityFeatures.customizeableSecurityPoliciesFeature]: true,
    [securityFeatures.basicIssueFilterSortFeature]: true,
    [securityFeatures.advancedIssueFilterSortFeature]: true,
  },
  complianceFeatures: {
    [complianceFeatures.licenseIdentificationFeature]: true,
    [complianceFeatures.licensingPolicyManagementFeature]: true,
    [complianceFeatures.discoveredLicensesFeature]: true,
    [complianceFeatures.defaultLicensePoliciesFeature]: true,
    [complianceFeatures.customizeableLicensePoliciesFeature]: true,
  },
  qualityFeatures: {
    [qualityFeatures.packageHealthSignalsFeature]: true,
    [qualityFeatures.defaultQualityPoliciesFeature]: true,
    [qualityFeatures.customizeableQualityPoliciesFeature]: true,
  },
  sbomFeatures: {
    [sbomFeatures.sbomGenerationFeature]: true,
    [sbomFeatures.sbomImportFeature]: 'Unlimited',
    [sbomFeatures.sbomExportFeature]: true,
    [sbomFeatures.vexAnnotationsFeature]: true,
    [sbomFeatures.appSbomFeature]: true,
    [sbomFeatures.publicSbomFeature]: true,
    [sbomFeatures.privateSbomFeature]: true,
  },
  reportingFeatures: {
    [reportingFeatures.attributionReportFeature]: true,
    [reportingFeatures.auditDueDiligenceReportFeature]: true,
    [reportingFeatures.globalBundleFeature]: true,
    [reportingFeatures.issueOverviewFeature]: true,
  },
  adminControlFeatures: {
    [adminControlFeatures.auditLogsFeature]: true,
    [adminControlFeatures.jiraIntegrationFeature]: true,
    [adminControlFeatures.slackIntegrationFeature]: true,
    [adminControlFeatures.ssoFeature]: true,
    [adminControlFeatures.rbacFeature]: true,
    [adminControlFeatures.teamFeature]: true,
  },
  supportFeatures: {
    [supportFeatures.priorityEmailFeature]: true,
    [supportFeatures.onboardingAndSupportFeature]: true,
    [supportFeatures.slaFeature]: true,
  },
  deploymentFeatures: {
    [deploymentFeatures.saasDeploymentFeature]: true,
    [deploymentFeatures.managedSaasDeploymentFeature]: true,
    [deploymentFeatures.onPremDeploymentFeature]: true,
  },
};

export default enterpriseTierFeatures;
